export const USERS_LIST_INIT = 'USERS_LIST_INIT'
export const USERS_LIST_GET = 'USERS_LIST_GET'
export const USERS_LIST_GET_SUCCESS = 'USERS_LIST_GET_SUCCESS'
export const USERS_LIST_GET_FAILURE = 'USERS_LIST_GET_FAILURE'
